import store, { initStoreTree, createNode } from '../store';
import { fetchAndDispatchDataToStore } from '../utils/fetchData';

const { storeCommon } = store;

const formateStruct = (structInfo) => {
    const {
        dom_wm_red_bag: domWmRedBag,
        dom_wm_every_day_coupon: domWmEveryDayCoupon,
        dom_wm_self_promotion_order: domWmSelfPromotionOrder,
        // 闪购每日优惠
        dom_sg_every_day_coupon: domSgEveryDayCoupon,
        // 不带sku的红包
        dom_sg_cps_unbind_coupon: domSgLargeRedBag,
        // 领券后，请求券可用商家
        dom_sg_cps_unbind_coupon_poi: domSgLargeRedBagPoi,
        // 用于请求带下挂菜的商家列表
        dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon,
        // 请求闪购v3中的红包1
        dom_sg_cps_unbind_multi_poi_1: domSgMultiPoi1,
        // 请求闪购v3中的红包2
        dom_sg_cps_unbind_multi_poi_2: domSgMultiPoi2,
        // 请求闪购v3中的红包3
        dom_sg_cps_unbind_multi_poi_3: domSgMultiPoi3,
    } = structInfo;

    return {
        domWmRedBag,
        domWmEveryDayCoupon,
        domWmSelfPromotionOrder,
        domSgEveryDayCoupon,
        domSgLargeRedBag,
        domSgLargeRedBagPoi,
        domSgSkuCoupon,
        domSgMultiPoi1,
        domSgMultiPoi2,
        domSgMultiPoi3,
    };
};
// 控制哪些模块要展示
export const initIsShow = () => {
    const { structInfo } = storeCommon;

    const {
        domWmRedBag,
        domWmEveryDayCoupon,
        domSgEveryDayCoupon,
        domSgLargeRedBag,
        domSgSkuCoupon,
        domWmSelfPromotionOrder,
        domSgMultiPoi1,
        domSgMultiPoi2,
        domSgMultiPoi3,
    } = formateStruct(structInfo.struct);

    const storeWmRedBag = store[domWmRedBag.recallBizId];
    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
    const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];

    const storeWmOrderCashBack = domWmSelfPromotionOrder ? store[domWmSelfPromotionOrder.recallBizId] : {};
    const storeSgLargeRedBag = domSgLargeRedBag ? store[domSgLargeRedBag.recallBizId] : {};
    const storeSgSkuCoupon = domSgSkuCoupon ? store[domSgSkuCoupon.recallBizId] : {};

    const storeSgMultiPoi1 = domSgMultiPoi1 ? store[domSgMultiPoi1.recallBizId] : {};
    const storeSgMultiPoi2 = domSgMultiPoi2 ? store[domSgMultiPoi2.recallBizId] : {};
    const storeSgMultiPoi3 = domSgMultiPoi3 ? store[domSgMultiPoi3.recallBizId] : {};

    storeWmRedBag.isShow = domWmRedBag && domWmRedBag.isShow && storeWmRedBag && storeWmRedBag.discountData.redBagList.length > 0;

    storeWmEveryDayCoupon.isShow =
        domWmEveryDayCoupon &&
        domWmEveryDayCoupon.isShow &&
        storeWmEveryDayCoupon &&
        storeWmEveryDayCoupon.poiData.poiList.length > 0 &&
        storeWmEveryDayCoupon.discountData.couponList.length > 0;

    storeWmOrderCashBack.isShow =
        domWmSelfPromotionOrder && domWmSelfPromotionOrder.isShow && storeWmOrderCashBack && storeWmOrderCashBack.poiData.poiList.length > 0;

    storeSgEveryDayCoupon.isShow =
        domSgEveryDayCoupon &&
        domSgEveryDayCoupon.isShow &&
        storeSgEveryDayCoupon &&
        storeSgEveryDayCoupon.poiData.poiList.length > 0 &&
        storeSgEveryDayCoupon.discountData.couponList.length > 0;

    storeSgLargeRedBag.isShow = domSgLargeRedBag && domSgLargeRedBag.isShow && storeSgLargeRedBag && storeSgLargeRedBag.discountData.redBagList.length > 0;

    // storeSgLargeRedBagPoi.isShow =
    //     domSgLargeRedBag &&
    //     domSgLargeRedBag.isShow &&
    //     domSgLargeRedBagPoi.isShow &&
    //     storeSgLargeRedBagPoi.discountData.redBagList.length > 0;

    // storeSgLargeRedBagPoi.discountData.couponRecallBizId =
    //     storeSgLargeRedBag.recallBizId;

    storeSgSkuCoupon.isShow = domSgSkuCoupon && domSgSkuCoupon.isShow && storeSgSkuCoupon && storeSgSkuCoupon.discountData.redBagList.length > 0;

    storeSgMultiPoi1.isShow =
        domSgMultiPoi1 &&
        domSgMultiPoi1.isShow &&
        storeSgMultiPoi1 &&
        storeSgMultiPoi1.discountData.redBagList.length > 0 &&
        storeSgMultiPoi1.poiData.poiList.length > 0;

    storeSgMultiPoi2.isShow =
        domSgMultiPoi2 &&
        domSgMultiPoi2.isShow &&
        storeSgMultiPoi2 &&
        storeSgMultiPoi2.discountData.redBagList.length > 0 &&
        storeSgMultiPoi2.poiData.poiList.length > 0;

    storeSgMultiPoi3.isShow =
        domSgMultiPoi3 &&
        domSgMultiPoi3.isShow &&
        storeSgMultiPoi3 &&
        storeSgMultiPoi3.discountData.redBagList.length > 0 &&
        storeSgMultiPoi3.poiData.poiList.length > 0;
};

export const handleData = async () => {
    const { structInfo } = storeCommon;

    // 解构结构信息，强依赖于后端。
    const {
        domWmRedBag,
        domWmEveryDayCoupon,
        domSgEveryDayCoupon,
        domSgLargeRedBag,
        domSgLargeRedBagPoi,
        domSgSkuCoupon,
        domWmSelfPromotionOrder,
        domSgMultiPoi1,
        domSgMultiPoi2,
        domSgMultiPoi3,
    } = formateStruct(structInfo.struct);

    const firstFetchModule = [
        fetchAndDispatchDataToStore(store[domWmRedBag.recallBizId]),
        fetchAndDispatchDataToStore(store[domWmEveryDayCoupon.recallBizId]),
        fetchAndDispatchDataToStore(store[domSgEveryDayCoupon.recallBizId]),
    ];

    // 请求不带sku的红包
    // if (domSgLargeRedBagPoi && domSgLargeRedBagPoi.isShow) {
    //     firstFetchModule.push(
    //         fetchAndDispatchDataToStore(
    //             store[domSgLargeRedBagPoi.recallBizId],
    //             domSgLargeRedBag.recallBizId,
    //         ),
    //     );
    // }
    // 大额红包
    if (domSgLargeRedBag && domSgLargeRedBag.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domSgLargeRedBag.recallBizId], '', domSgLargeRedBagPoi.recallBizId));
    }

    // 请求带sku的商家列表，并且点击去使用时，弹窗中的列表使用domSgLargeRedBagPoi.recallBizId请求
    if (domSgSkuCoupon && domSgSkuCoupon.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domSgSkuCoupon.recallBizId], '', domSgLargeRedBagPoi.recallBizId));
    }

    if (domWmSelfPromotionOrder && domWmSelfPromotionOrder.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domWmSelfPromotionOrder.recallBizId]));
    }

    // 闪购v3 商家1
    if (domSgMultiPoi1 && domSgMultiPoi1.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domSgMultiPoi1.recallBizId]));
    }
    // 闪购v3 商家2

    if (domSgMultiPoi2 && domSgMultiPoi2.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domSgMultiPoi2.recallBizId]));
    }
    // 闪购v3 商家3
    if (domSgMultiPoi3 && domSgMultiPoi3.isShow) {
        firstFetchModule.push(fetchAndDispatchDataToStore(store[domSgMultiPoi3.recallBizId]));
    }

    try {
        await Promise.allSettled(firstFetchModule);
    } catch (error) {
        console.error(error);
        // 业务请求报错单独上报
        throw error;
    }
};
/**
 * 初始化缓存结构，强依赖于后端接口
 * @param {*} tabsInfo
 */
export const initStore = function (tabsInfo, struct) {
    const rootNode = { recallBizId: 'root', children: tabsInfo.infos, struct };

    store.treeRoot = initStoreTree(rootNode);

    // 兼容不在showcatelist接口的模块, 手动创建
    Array.isArray(struct) &&
        struct.forEach((item) => {
            item && createNode(item.recallBizId);
        });
};
